<template>
  <div class="show-tips" :style="{ backgroundColor: color }">
    <p>{{ message }}</p>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    message: {
      type: String,
      default: "提示信息",
    },
  },
  computed: {
    color() {
      if (this.message === "未开始") {
        return "#f00";
      } else if (this.message === "报名中") {
        return "#67C23A";
      } else if (this.message === "已结束") {
        return "#909399";
      } else {
        return "#409eff";
      }
    },
  },
};
</script>
<style scoped>
.show-tips {
  width: 76.7px;
  height: 23px;
  line-height: 23px;
  border-radius: 11.5px 0 11.5px 0;
  text-align: center;
  color: #fff;
  font-size: 14px;
}
</style>
